import { render, staticRenderFns } from "./addSecurity.vue?vue&type=template&id=50ee68fc&"
import script from "./addSecurity.vue?vue&type=script&lang=js&"
export * from "./addSecurity.vue?vue&type=script&lang=js&"
import style0 from "./addSecurity.vue?vue&type=style&index=0&id=50ee68fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports